// extracted by mini-css-extract-plugin
export default {"section":"ProductSection_section__zmDz3","caution":"ProductSection_caution__QJfgC"};